import {BackgroundView, LAYERS} from '@gongxigames/framework/slot';
import {Layer} from '@pixi/layers';
import {GameBackgroundAnimationData, GameCommonConfig} from 'src/configs/GameConfig';

export class GameBackgroundView extends BackgroundView {
    protected getSpineName(): string {
        const commonConfig = this._gameConfig.commonConfig as GameCommonConfig;
        let animationsData: GameBackgroundAnimationData;

        if (commonConfig) {
            animationsData = commonConfig.backgroundAnimation!.find(data => data.backgroundId === this._backgroundId)!;
        }

        // TODO: refactor WTF?!
        return animationsData!.spineName ? animationsData!.spineName : '';
    }

    public static layer: Layer = LAYERS.BACKGROUND;
}
